export default __webpack_public_path__ + "static/media/video1.452cb574.mp4";